import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateVoiceItem,
  DominateVoiceList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateVoiceItem';
import { VoiceStyleOptionIdType } from '@/pages/Onboarding/options/VoiceStyle/types';
import { getVoiceStyleTitleById } from '@/pages/Onboarding/options/VoiceStyle/utils/getVoiceStyle';
import { VOICE_STYLE_OPTIONS } from '@/pages/Onboarding/options/VoiceStyle/VOICE_STYLE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './VoiceStyle.styles';

export const ScreenVoiceStyle: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'VoiceStyle',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const voiceStyle = form.watch('voice_style');
  const hasSelection = Boolean(voiceStyle);

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['voice_style']>,
  ) => {
    form.setValue('voice_style', option.id);
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        voice_style: getVoiceStyleTitleById(voiceStyle),
      },
    });
    wizard.nextStep();
  };

  const getAudioSrc = (id: OnbOptionType<VoiceStyleOptionIdType>['id']) => {
    return `/assets/layout-own-ai-dominate/voice_style/${id}.mp3`;
  };

  const handleBack = () => {
    wizard.goToStep('dominatrix_visual_style');
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation onBack={handleBack} />
      <OwnAiTitle>What kind of voice should make you obey?</OwnAiTitle>

      <IonContent>
        <DominateVoiceList>
          {VOICE_STYLE_OPTIONS.map((option) => (
            <DominateVoiceItem
              key={option.id}
              isSelected={voiceStyle === option.id}
              onClick={() => handleSelect(option)}
              title={option.title}
              audioSrc={getAudioSrc(option.id)}
            />
          ))}
        </DominateVoiceList>
      </IonContent>

      {hasSelection && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
        />
      )}
    </PageStyles>
  );
};
